module.exports = __webpack_public_path__ + "static/media/balls.79e52fae.gif";